<template>
    <div v-loading="loading">
        <!-- 搜索条件 -->
        <el-row  class="viewKPITitle">
            <el-col  :class="pType==0?'show':'hidden'" :span="4">
                <el-date-picker size="small" v-model="dateMonth" type="month" placeholder="选择月"></el-date-picker>
            </el-col>
             <el-col :class="pType==0?'hidden':'show'" :span="4">
                <el-date-picker 
                    size="small"
                    v-model="yearValue"
                    type="year"
                    placeholder="选择年">
                </el-date-picker>
            </el-col>
            <el-col :class="pType==0?'hidden':'show'" :span="4">
                <el-select size="small" v-model="dateJidu" placeholder="请选择季度">
                    <el-option label="Q1" value="Q1"></el-option>
                    <el-option label="Q2" value="Q2"></el-option>
                    <el-option label="Q3" value="Q3"></el-option>
                    <el-option label="Q4" value="Q4"></el-option>
                </el-select>
            </el-col>
            <el-col :span="4">
                <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
            </el-col>
        </el-row>
        <!-- 头部信息 -->
        <div style="margin-top:20px;" class="viewKPITitle">
            <el-row style="margin-top:10px;">
                <el-col :span="6">
                    <span v-if="KPIItems.length>0">被考核者姓名：{{AllKPIInfo.userName}}</span>
                </el-col>
                <el-col :span="6">
                    <span v-if="KPIItems.length>0">被考核者岗位：{{AllKPIInfo.duty}}</span>
                </el-col>
                <el-col :span="6">
                    <span v-if="KPIItems.length>0">被考核者工号：{{AllKPIInfo.list[0].UserCode}}</span>
                </el-col>
                <el-col :span="6">
                    <span v-if="KPIItems.length>0">考核周期：{{AllKPIInfo.period}}{{pType==0?'月':'季度'}}</span>
                </el-col>
            </el-row>
            <el-row style="margin-top:10px;">
                <el-col :span="6">
                    <span v-if="KPIItems.length>0">考核者姓名：{{AllKPIInfo.leadName}}</span>
                </el-col>
                <el-col :span="6">
                    <!-- {{viewKPITitle.Period}}{{viewKPITitle.PeriodType==1?'季度':'月'}} -->
                    <span v-if="KPIItems.length>0">考核者岗位：{{AllKPIInfo.leadDuty}}</span>
                </el-col>
            </el-row>
        </div>
        <!-- 考核列表信息 -->
        <el-table border :data="KPIItems" show-summary style="width: 100%;margin-top:20px;" v-loading="loading" size="small">
            <el-table-column  min-width="18" prop="KPI"  label="KPI名称"></el-table-column>
            <el-table-column  min-width="18" prop="KPIWeight" label="KPI权重"></el-table-column>
            <el-table-column prop="Explain" min-width="18" label="指标说明"></el-table-column>
            <el-table-column prop="Contents" min-width="24" label="考核细则"></el-table-column>
            <el-table-column  min-width="18" label="周期">
                <template slot-scope="scope">{{ scope.row.PeriodType==0?'月度':'季度' }}</template>
            </el-table-column>
            <el-table-column prop="Execution" min-width="18" label="完成情况"></el-table-column>
            <el-table-column prop="SelfScore" min-width="10" label="自评评分"></el-table-column>
            <el-table-column prop="LeadScore" min-width="10" label="直属领导评分"></el-table-column>
        </el-table>
    </div>
</template>
<script>
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetMyKPI } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
    props: {
        pt: {
            Type: Number
        },
        activeName:{
            Type:String
        }
    },
    data(){
        return{
            pType: this.pt,
            loading:true,
            userinfo:{},
            AllKPIInfo:{},
            KPIItems:[],
            yearValue:'',//季度选择年
            year:'',//选择年
            month:'',//选择月
            dateMonth:'',//当前选择月份
            dateJidu:'',//季度
        }
    },
    created() {
        //获取当前登录用户信息
        this.GetUserinfo();
        
        
        var date=new Date();
        this.year=date.getFullYear();
        this.month=date.getMonth()+1;
        if(this.pType==1){
            //季度时 选择当前季度
            if(this.month>=1&&this.month<=3){
                this.month='Q1';
            }
            else if(this.month>=4&&this.month<=6){
                this.month='Q2';
            }
            else if(this.month>=7&&this.month<=9){
                this.month='Q3';
            }
            else{
                this.month='Q4';
            }
        }
        //获取我的KPI
        this.GetMyKPI();
    },
    methods: {
        //条件搜索
        SearchByName:function(){
            if(this.pType==0){
                //获取的年月需要转换
                this.year=this.dateMonth.getFullYear();
                this.month=this.dateMonth.getMonth()+1;           
            }
            else{
                //季度直接使用 
                this.month=this.dateJidu;
                this.year=this.yearValue.getFullYear();
            }
            //获取我的KPI
            this.GetMyKPI();
            if(this.KPIItems.length<=0){
                this.$message({
                    message: '暂无数据',
                    type: 'success'
                });
            }
        },
        //获取当前登录用户信息
        GetUserinfo:function(){
            this.userinfo=GetCurrentUserInfo();
        },
        //获取我的KPI
        GetMyKPI:async function(year,month){
            await GetMyKPI(this.userinfo.UserCode,this.pType,this.month,this.year).then(res=>{
                // if(res.totalCount<=0){
                //     this.$message({
                //         message: '暂无数据',
                //         type: 'success'
                //     });

                //     return false;
                // }
                this.AllKPIInfo=res;
                this.KPIItems=res.list;
                this.loading=false;
            });
        }
    },
}
</script>
<style lang="less" scoped>
.viewKPITitle {
  text-align: left;
  font-size: 14px;
  color: #72767b;
}
.show{
    display: block;
}
.hidden{
    display: none;;
}
</style>